import A11yDialog from 'a11y-dialog';
export default () => ({
    csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    modalTitle: "",
    modalIntro: "",
    modalWarningMessage: "",
    copiedLinkMessage: "Link copied to clipboard!",
    copiedLink: false,
    buttonLabel: {
        student: "Generate Student Link",
        teacherShare: "Share Teacher Link",
        teacher: "Generate Teacher Link"
    },
    buttonShareLabel: {
        student: "Share Student Link",
        teacher: "Share Teacher Link"
    },
    modalDetail: {
        student: {
            title: "Share this link with your students",
            intro: "To share this resource with your students, copy the link below.",
            warningMessage: "Use the ‘Generate Teacher Link’ in the header section to share the resource with your colleagues.",
        },
        teacher: {
            title: "Share this link with your colleagues",
            intro: "To share this resource with people in your organisation, copy the link below. Only members can access and share this resource.",
            warningMessage: "<strong>Note:</strong> Use ‘Generate Student Link’ in the Tools panel to share this resource with students – including added Teacher Notes.",
        }
    },
    shareableLinkDialog: null,
    type: false,
    link: "",
    resourceId: null,
    resourceType: '',
    async resourceShareableLinkInit() {
        this.type = this.$root.dataset.type
        if (this.type === "student") {
            this.modalTitle = this.modalDetail.student.title;
            this.modalIntro = this.modalDetail.student.intro;
            this.modalWarningMessage = this.modalDetail.student.warningMessage;
        } else if (this.type === "teacher") {
            this.modalTitle = this.modalDetail.teacher.title;
            this.modalIntro = this.modalDetail.teacher.intro;
            this.modalWarningMessage = this.modalDetail.teacher.warningMessage;
        }
        this.link = this.$root.dataset.link;
        this.resourceId = this.$root.dataset.resourceId;
        this.resourceType = this.$root.dataset.resourceType || '';
    },
    async copyLink() {
        try {
            await navigator.clipboard.writeText(this.link);
            this.copiedLink = true;
        } catch (err) {
            console.error("Failed to copy link: ", err);
            this.copiedLink = false;
            this.copiedLinkMessage = "Failed to copy link. Please try again.";
        }
    },
    async triggerShareableLinkModal(event) {
        event.preventDefault();
        if (!this.link) {
            await this.generateLink()
        }
        const modalId = event.currentTarget.dataset.modalId
        const shareableLinkModal = document.getElementById(modalId);

        if (!this.shareableLinkDialog) {
            this.shareableLinkDialog = new A11yDialog(shareableLinkModal);

            this.shareableLinkDialog.on('show', () => {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                document.body.style.setProperty('--scroll-y', `${scrollY}px`);
                document.body.classList.add('modal--open');
            });

            this.shareableLinkDialog.on('hide', () => {
                const scrollY = parseInt(document.body.style.getPropertyValue('--scroll-y') || '0');
                document.body.classList.remove('modal--open');
                window.scrollTo(0, scrollY);
            });
        }

        this.shareableLinkDialog.show();
    },
    async generateLink() {
        const response = await fetch(`/resources/generate-shareable-link/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": this.csrfToken
            },
            body: JSON.stringify({
                type: this.type,
                resource_id: this.resourceId,
                resource_type: this.resourceType,
            })
        })
        if (!response.ok) {
            const errorData = await response.json();
            console.error("Error generating link:", errorData);
            return;
        }
        const data = await response.json();
        this.link = data.link;
    }
})